module.exports = __webpack_public_path__ + "img/new-tab.6b0ccea7.svg";